import PropTypes from 'prop-types';
import VipPill from '@/components/vip/VipPill';
import { useMyVip } from '@/hooks/useMyVip';

/**
 * The signed-in customer's own VIP badge (founder, 2026-10-25). Recognition
 * only: it shows on Profile, the account menu, Home, Rewards and their trip
 * pages, and promises nothing. Renders nothing for anyone who isn't VIP.
 */
export default function MyVipBadge({ className }) {
  const vip = useMyVip();
  if (!vip) return null;
  return <VipPill title="Defera VIP" srText="" className={className} />;
}

MyVipBadge.propTypes = {
  className: PropTypes.string,
};
